export default {"src":"/_next/static/media/0x1a93b23281cc1cde4c4741353f3064709a16197d.668df216.svg","height":284,"width":284,"blurWidth":0,"blurHeight":0};